/**
 * 设备类型检测工具
 * 区分：pc / tablet / mobile
 */
export const deviceDetector = {
  // 获取设备类型
  getDeviceType() {
    const width = window.innerWidth;
    // 自定义断点（可根据需求调整）
    const MOBILE_MAX = 767;    // 手机端最大宽度
    const TABLET_MAX = 1024;   // 平板端最大宽度

    if (width <= MOBILE_MAX) {
      return 'mobile'; // H5/手机端
    } else if (width <= TABLET_MAX) {
      return 'tablet'; // 平板端
    } else {
      return 'pc';     // PC端
    }
  },

  // 判断是否为移动端（手机）
  isMobile() {
    return this.getDeviceType() === 'mobile';
  },

  // 判断是否为平板
  isTablet() {
    return this.getDeviceType() === 'tablet';
  },

  // 判断是否为PC
  isPc() {
    return this.getDeviceType() === 'pc';
  }
};
